import React, { Component } from 'react'
import Select from 'react-select';
import styles from '../css/ShowCustomerV2.module.css';
import { getInformationWithData, create_Delete_Update_Information, getInformationWithDataV3 } from '../services/CABE.js'
import { AiFillEdit, AiOutlineClose, AiFillPrinter, AiOutlineUserAdd, AiOutlineSave, AiOutlineArrowLeft, AiFillStar, AiOutlineStar, AiOutlineStop, AiOutlineCheckCircle } from "react-icons/ai";
import { FaRegListAlt, FaUserAlt, FaAddressBook } from "react-icons/fa";
import { getValueCookie } from '../services/cookieService';
import { getIndexElement } from '../functions/searchInObject';
import "../css/general-style.css"
import LoadingWindow from '../components/LoadingWindow';
import { Menu } from "../components/Menu/Menu";
import Swal from 'sweetalert2';


export default class ShowCustomer extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        // ── View router ───────────────────────────────────────────────────
        // 'landing' | 'create' | 'detail' | 'edit'
        view: 'landing',

        // ── Customer form (create & edit) ─────────────────────────────────
        Customer: {
            CustomerNo: '',
            CustomerName: '',
            EmailAddress: '',
            ContactName: '',
            TelephoneNo: '',
            PriceLevel: '1',
            Fax: '',
            AddressLine1: '',
            ZipCode: '',
            City: '',
            State: '',
            Country: 'The United States of America',
            SalespersonNo: getValueCookie('SalesPerson'),
            Taxable: 'NONTAX',
            TermsCode: '00',
            Route: 'SinRuta',
            New: 1,
            OrderType: 'customerManager',
            CreditLimit: 0,
        },

        // ── Select options (company-aware) ────────────────────────────────
        optionsSelect1: [
            { value: 'NONTAX',  label: 'NONTAX'  },
            { value: 'DEFAULT', label: 'DEFAULT' },
        ],
        optionsSelect2: getValueCookie('CompanyId') === '3' ? [
            { value: 'SinRuta',     label: 'Sin Ruta'    },
            { value: 'Supermarket', label: 'Supermarket' },
            { value: 'Pallet',      label: 'Pallet'      },
            { value: 'Warehouse',   label: 'Warehouse'   },
            { value: 'Distributor', label: 'Distributor' },
            { value: 'Nebraska',    label: 'Nebraska'    },
        ] : [
            { value: 'SinRuta',          label: 'Sin Ruta'          },
            { value: 'Albertville',      label: 'Albertville'       },
            { value: 'Atlanta',          label: 'Atlanta'           },
            { value: 'Birmingham',       label: 'Birmingham'        },
            { value: 'Chattanooga',      label: 'Chattanooga'       },
            { value: 'City Farmers',     label: 'City Farmers'      },
            { value: 'Columbus/Opelika', label: 'Columbus/Opelika'  },
            { value: 'Dalton',           label: 'Dalton'            },
            { value: 'Florence',         label: 'Florence'          },
            { value: 'Gainsville/Buford',label: 'Gainsville/Buford' },
            { value: 'Knoxville',        label: 'Knoxville'         },
            { value: 'Mobile',           label: 'Mobile'            },
            { value: 'Montgomery',       label: 'Montgomery'        },
            { value: 'Pallet Altitude',  label: 'Pallet Altitude'   },
            { value: 'Rome/Cedartown',   label: 'Rome/Cedartown'    },
            { value: 'Talpa',            label: 'Talpa'             },
            { value: 'Tuscaloosa',       label: 'Tuscaloosa'        },
            { value: 'Valdosta',         label: 'Valdosta'          },
        ],
        optionsSelect3: getValueCookie('CompanyId') === '3' ? [
            { value: '00', label: 'Pay in Advance' },
            { value: '01', label: 'FOB Taiwan'     },
            { value: '07', label: 'Net 07 Days'    },
            { value: '10', label: 'Net 10 Days'    },
            { value: '15', label: 'Net 15 Days'    },
            { value: '21', label: 'Net 21 Days'    },
            { value: '30', label: 'Net 30 Days'    },
            { value: '45', label: 'Net 45 Days'    },
        ] : [
            { value: '00', label: 'Pay in Advance' },
        ],
        optionsSelect4: getValueCookie('CompanyId') === '3' ? [
            { value: '1', label: '01' },
            { value: '2', label: '02' },
            { value: '3', label: '03' },
        ] : [
            { value: '1', label: '01' },
            { value: '2', label: '02' },
        ],
        selectedOption1: { value: 'NONTAX', label: 'NONTAX'          },
        selectedOption2: { value: 'SinRuta', label: 'Sin Ruta'       },
        selectedOption3: { value: '00',      label: 'Pay in Advance' },
        selectedOption4: { value: '1',       label: '01'             },
        securityDisabled:
            getValueCookie('SalesPerson') === '0000' || getValueCookie('SalesPerson') === 'JC'
                ? false
                : true,
        isNewCustomer: false,

        // ── Customer browse / detail ──────────────────────────────────────
        customerList: [],
        customerListFilter: [],
        selectedCustomer: null,
        invoiceList: [],

        // ── Invoice modal ─────────────────────────────────────────────────
        selectedInvoice: {
            InvoiceNo: '',
            InvoiceType: '',
            InvoiceDate: '',
            CustomerNo: '',
            Comment: '',
            Total: 0,
            totalPrice: 0,
            totalWeight: 0,
            totalQShipped: 0,
            items: [],
        },

        // ── Contacts sub-module ───────────────────────────────────────────────
        contacts: [],
        showContactForm: false,
        contactFormMode: 'new',   // 'new' | 'edit'
        editingContactId: null,
        contactForm: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            position: '',
        },
    }

    componentDidMount() {
        this.getCustomers();
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Utility
    // ─────────────────────────────────────────────────────────────────────────

    formatCurrency = (quantity) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(quantity) || 0);

    formatDate = (date) => {
        const d = date instanceof Date ? date : new Date(date);
        const year  = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day   = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    textTermsCode(code) {
        const n = Number(code);
        switch (n) {
            case 0:  return 'Pay in Advance';
            case 1:  return 'FOB Taiwan';
            case 7:  return 'Net 07 Days';
            case 10: return 'Net 10 Days';
            case 15: return 'Net 15 Days';
            case 21: return 'Net 21 Days';
            case 30: return 'Net 30 Days';
            case 45: return 'Net 45 Days';
            default: return String(code || '');
        }
    }

    contains(parameter, word) {
        if (parameter && word) {
            return parameter.toString().toLowerCase().includes(word.toLowerCase());
        }
        return false;
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Customer list
    // ─────────────────────────────────────────────────────────────────────────

    getCustomers = async () => {
        const salesPerson =
            getValueCookie('TypeUser') === '8' ? '0000' : getValueCookie('SalesPerson');
        const response = await getInformationWithDataV3('/customer/getListV3', {
            SalespersonNo: salesPerson,
            idCompany: Number(getValueCookie('CompanyId')),
            search: '',
        });
        if (response.status.code === 1 && response.data.length > 0) {
            const customers = response.data;
            this.setState({
                customerList: customers,
                customerListFilter: customers.slice(0, 10),
            });
        }
    }

    searchCustomer = e => {
        const word = e.target.value;
        if (word) {
            this.setState({
                customerListFilter: this.state.customerList.filter(c =>
                    this.contains(c.CustomerNo, word) || this.contains(c.name, word)
                ),
            });
        } else {
            this.setState({ customerListFilter: this.state.customerList.slice(0, 10) });
        }
    }

    selectCustomer = (customer) => {
        const searchInput = document.getElementById('searchCustomerFilter');
        if (searchInput) searchInput.value = '';
        this.setState({
            selectedCustomer: customer,
            invoiceList: [],
            contacts: [],
            customerListFilter: this.state.customerList.slice(0, 10),
            view: 'detail',
        });
        this.getCustomerInvoices(customer.customerNo);
        this.getContacts(customer.customerNo);
    }

    clearCustomer = () => {
        this.setState({
            view: 'landing',
            selectedCustomer: null,
            invoiceList: [],
            contacts: [],
            showContactForm: false,
            selectedInvoice: { InvoiceNo: '', items: [] },
            customerListFilter: this.state.customerList.slice(0, 10),
        });
    }

    getCustomerInvoices = async (CustomerNo, Start = '', End = '') => {
        try {
            const { data } = await getInformationWithData(
                '/invoice/history/header/customerV2',
                { CustomerNo, Start, End }
            );
            if (data) this.setState({ invoiceList: data });
        } catch (err) {
            console.error('getCustomerInvoices:', err);
        }
    }

    searchByDates = async () => {
        const { selectedCustomer } = this.state;
        if (!selectedCustomer) return;
        const Start = document.getElementById('dateStart').value;
        const End   = document.getElementById('dateEnd').value;
        await this.getCustomerInvoices(selectedCustomer.customerNo, Start, End);
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Invoice modal
    // ─────────────────────────────────────────────────────────────────────────

    openInvoiceModal = async (invoice) => {
        // Reset items so modal shows "loading" until data arrives
        this.setState({ selectedInvoice: { ...invoice, items: [] } });
        try {
            const { data } = await getInformationWithData(
                '/v2/get-invoice/detail',
                { InvoiceNo: invoice.InvoiceNo }
            );
            if (data && data.items) {
                this.setState({ selectedInvoice: { ...invoice, ...data } });
            }
        } catch (err) {
            console.error('openInvoiceModal:', err);
        }
    }

    handlePrint = () => {
        window.print();
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Contacts
    // ─────────────────────────────────────────────────────────────────────────

    getContacts = async (customerNo) => {
        try {
            const companyId = Number(getValueCookie('CompanyId'));
            const { data } = await getInformationWithData(
                '/customer/contacts/get',
                { customerNo, companyId }
            );
            this.setState({ contacts: data || [] });
        } catch (err) {
            console.error('getContacts:', err);
        }
    }

    setContactField = (field, value) => {
        this.setState(prev => ({
            contactForm: { ...prev.contactForm, [field]: value }
        }));
    }

    openAddContact = () => {
        this.setState({
            showContactForm: true,
            contactFormMode: 'new',
            editingContactId: null,
            contactForm: { firstName: '', lastName: '', email: '', phone: '', position: '' },
        });
    }

    startEditContact = (contact) => {
        this.setState({
            showContactForm: true,
            contactFormMode: 'edit',
            editingContactId: contact.id,
            contactForm: {
                firstName: contact.firstName || '',
                lastName:  contact.lastName  || '',
                email:     contact.email     || '',
                phone:     contact.phone     || '',
                position:  contact.position  || '',
            },
        });
    }

    saveContact = async () => {
        const { contactForm, contactFormMode, editingContactId, selectedCustomer } = this.state;
        if (!contactForm.firstName.trim()) {
            Swal.fire({ icon: 'warning', title: 'Validation', text: 'First Name is required.', confirmButtonColor: '#2563EB' });
            return;
        }
        try {
            const payload = {
                id:         contactFormMode === 'edit' ? editingContactId : 0,
                customerNo: selectedCustomer.customerNo,
                companyId:  Number(getValueCookie('CompanyId')),
                ...contactForm,
            };
            const result = await getInformationWithData('/customer/contacts/upsert', payload);
            if (result.status.code === 1) {
                this.setState({ showContactForm: false });
                this.getContacts(selectedCustomer.customerNo);
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: 'Could not save contact.' });
            }
        } catch (err) {
            console.error('saveContact:', err);
        }
    }

    setPrimaryContact = async (id) => {
        const { selectedCustomer } = this.state;
        try {
            await getInformationWithData('/customer/contacts/set-primary', {
                id,
                customerNo: selectedCustomer.customerNo,
                companyId:  Number(getValueCookie('CompanyId')),
            });
            this.getContacts(selectedCustomer.customerNo);
        } catch (err) {
            console.error('setPrimaryContact:', err);
        }
    }

    toggleContact = async (id, currentlyActive) => {
        const { selectedCustomer } = this.state;
        const label = currentlyActive ? 'deactivate' : 'activate';
        Swal.fire({
            icon: 'question',
            title: `${label.charAt(0).toUpperCase() + label.slice(1)} contact?`,
            text: `Are you sure you want to ${label} this contact?`,
            showCancelButton: true,
            confirmButtonColor: '#2563EB',
            confirmButtonText: 'Yes',
        }).then(async result => {
            if (result.isConfirmed) {
                await getInformationWithData('/customer/contacts/toggle', { id });
                this.getContacts(selectedCustomer.customerNo);
            }
        });
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Create / Edit — form helpers
    // ─────────────────────────────────────────────────────────────────────────

    /** Sync a react-select value from Customer state */
    StateSelectOption(stateKey, customerField, optionsKey) {
        const idx = getIndexElement(
            this.state[optionsKey], 'value', this.state.Customer[customerField]
        );
        this.setState({ [stateKey]: idx !== -1 ? this.state[optionsKey][idx] : this.state[optionsKey][0] });
    }

    onChangeSelects = (e, id) => {
        const temporal = { ...this.state.Customer };
        switch (id) {
            case 'Route':      temporal.Route     = e.value; this.setState({ selectedOption2: e }); break;
            case 'Tax':        temporal.Taxable   = e.value; this.setState({ selectedOption1: e }); break;
            case 'TermsCode':  temporal.TermsCode = e.value; this.setState({ selectedOption3: e }); break;
            case 'PriceLevel': temporal.PriceLevel = e.value; this.setState({ selectedOption4: e }); break;
            default: break;
        }
        this.setState({ Customer: temporal });
    }

    onTarget = e => {
        const { id, value } = e.target;
        const fieldMap = {
            'f-CustomerName':  'CustomerName',
            'f-EmailAddress':  'EmailAddress',
            'f-TelephoneNo':   'TelephoneNo',
            'f-Fax':           'Fax',
            'f-AddressLine1':  'AddressLine1',
            'f-ZipCode':       'ZipCode',
            'f-City':          'City',
            'f-State':         'State',
            'f-CreditLimit':   'CreditLimit',
        };
        if (fieldMap[id]) {
            this.setState(prev => ({
                Customer: { ...prev.Customer, [fieldMap[id]]: value }
            }));
        }
    }

    ClearCustomerForm = () => {
        this.setState({
            Customer: {
                CustomerNo: '',
                CustomerName: '',
                EmailAddress: '',
                ContactName: '',
                TelephoneNo: '',
                PriceLevel: '1',
                Fax: '',
                AddressLine1: '',
                ZipCode: '',
                City: '',
                State: '',
                Country: 'The United States of America',
                SalespersonNo: getValueCookie('SalesPerson'),
                Taxable: 'NONTAX',
                TermsCode: '00',
                Route: 'SinRuta',
                New: 1,
                OrderType: 'customerManager',
                CreditLimit: 0,
            },
            selectedOption1: { value: 'NONTAX', label: 'NONTAX'          },
            selectedOption2: { value: 'SinRuta', label: 'Sin Ruta'       },
            selectedOption3: { value: '00',      label: 'Pay in Advance' },
            selectedOption4: { value: '1',       label: '01'             },
            isNewCustomer: false,
        });
    }

    getNewCorrelativeNewCustomer = async () => {
        this.ModalLoading.current.showState(true);
        this.ClearCustomerForm();
        const data = {
            type: 'Customer',
            idCompany: getValueCookie('CompanyId'),
            SalespersonNo: getValueCookie('SalesPerson'),
        };
        while (true) {
            const result = await getInformationWithDataV3('/sales/get/correlativeV2', data);
            if (result.status.code === 1) {
                const CustomerNo = String(result.data[0].correlative).padStart(7, '0');
                this.setState(prev => ({
                    Customer: { ...prev.Customer, CustomerNo },
                    isNewCustomer: true,
                    view: 'create',
                }));
                break;
            }
        }
        this.ModalLoading.current.showState(false);
    }

    startEditCustomer = () => {
        const c = this.state.selectedCustomer;

        // Normalize PriceLevel: API may return '01' or 1 — options use '1','2','3'
        const rawLevel   = String(c.priceLevel || '1').replace(/^0+/, '') || '1';
        // Normalize TermsCode: convert number (30) → '30', keep string '30' as-is, pad to 2 chars
        const rawTerms   = String(c.termsCode !== undefined ? c.termsCode : '00');
        const termsCode  = rawTerms.padStart(2, '0');

        const Customer = {
            CustomerNo:    c.customerNo   || '',
            CustomerName:  c.name         || '',
            EmailAddress:  c.emailAddress || '',
            ContactName:   c.contactName  || '',
            TelephoneNo:   c.telephoneNo  || '',
            PriceLevel:    rawLevel,
            Fax:           c.fax          || '',
            AddressLine1:  c.addressLine1 || '',
            ZipCode:       c.zipCode      || '',
            City:          c.city         || '',
            State:         c.state        || '',
            Country:       c.country      || 'The United States of America',
            SalespersonNo: c.salespersonNo || getValueCookie('SalesPerson'),
            Taxable:       c.taxSchedule  || 'NONTAX',
            TermsCode:     termsCode,
            Route:         c.udf_ruta     || 'SinRuta',
            New: 0,
            OrderType: 'customerManager',
            CreditLimit:   c.creditLimit  || 0,
        };

        this.setState({ Customer, isNewCustomer: false, view: 'edit' }, () => {
            this.StateSelectOption('selectedOption1', 'Taxable',    'optionsSelect1');
            this.StateSelectOption('selectedOption2', 'Route',      'optionsSelect2');
            this.StateSelectOption('selectedOption3', 'TermsCode',  'optionsSelect3');
            this.StateSelectOption('selectedOption4', 'PriceLevel', 'optionsSelect4');
        });
    }

    saveCustomer = async () => {
        const { Customer } = this.state;
        if (!Customer.CustomerName.trim()) {
            Swal.fire({ icon: 'warning', title: 'Validation', text: 'Customer Name is required.', confirmButtonColor: '#2563EB' });
            return;
        }

        this.ModalLoading.current.showState(true);
        const result = await create_Delete_Update_Information('/customer/set', {
            Customer,
            idcompany:    getValueCookie('CompanyId'),
            SalespersonNo: getValueCookie('SalesPerson'),
            company:      getValueCookie('Company'),
        });
        this.ModalLoading.current.showState(false);

        if (result.status.code === 1) {
            const isCreate = Customer.New === 1;
            Swal.fire({
                icon: 'success',
                title: 'Done!',
                text: isCreate ? 'Customer created successfully!' : 'Customer updated successfully!',
                confirmButtonColor: '#2563EB',
            }).then(() => {
                this.getCustomers();
                if (isCreate) {
                    this.ClearCustomerForm();
                    this.setState({ view: 'landing' });
                } else {
                    // Refresh selectedCustomer display fields from form
                    const c = this.state.selectedCustomer;
                    this.setState({
                        selectedCustomer: {
                            ...c,
                            name:         Customer.CustomerName,
                            emailAddress: Customer.EmailAddress,
                            telephoneNo:  Customer.TelephoneNo,
                            fax:          Customer.Fax,
                            addressLine1: Customer.AddressLine1,
                            zipCode:      Customer.ZipCode,
                            city:         Customer.City,
                            state:        Customer.State,
                            udf_ruta:     Customer.Route,
                            priceLevel:   Customer.PriceLevel,
                            termsCode:    Customer.TermsCode,
                            creditLimit:  Customer.CreditLimit,
                        },
                        view: 'detail',
                    });
                }
            });
        } else {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong. Please try again.' });
        }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Render: Landing
    // ─────────────────────────────────────────────────────────────────────────

    renderLanding() {
        return (
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className={styles.modernCard}>
                        <div className={styles.cardBodyCustom}>
                            <div className={styles.emptyState}>
                                <div className={styles.emptyIcon}><FaUserAlt /></div>
                                <h2 className={styles.emptyTitle}>Customer Management</h2>
                                <p className={styles.emptyText}>
                                    Browse and manage existing customers, or register a new one
                                </p>
                                <div className="row g-3 justify-content-center mt-2">
                                    <div className="col-sm-12 col-md-5">
                                        <button
                                            className={styles.browseBtn}
                                            data-bs-toggle="modal"
                                            data-bs-target="#browseCustomersModal"
                                        >
                                            <FaRegListAlt />
                                            <span>Browse / Search Customers</span>
                                        </button>
                                    </div>
                                    <div className="col-sm-12 col-md-5">
                                        <button
                                            className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                            style={{ width: '100%', justifyContent: 'center' }}
                                            onClick={this.getNewCorrelativeNewCustomer}
                                        >
                                            <AiOutlineUserAdd />
                                            <span>New Customer</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Render: Create / Edit form  (isNew = true → create, false → edit)
    // ─────────────────────────────────────────────────────────────────────────

    renderCustomerForm(isNew) {
        const {
            Customer,
            selectedOption1, selectedOption2, selectedOption3, selectedOption4,
            optionsSelect1,  optionsSelect2,  optionsSelect3,  optionsSelect4,
            securityDisabled,
        } = this.state;
        const isAdmin    = getValueCookie('TypeUser') === '1';
        const nameDisabled = !isNew && !isAdmin;

        return (
            <div className={`${styles.customerContent} ${styles.active}`}>

                {/* ── Breadcrumb ── */}
                <button
                    className={styles.viewBreadcrumb}
                    onClick={() => this.setState({ view: isNew ? 'landing' : 'detail' })}
                >
                    <AiOutlineArrowLeft />
                    <span>{isNew ? 'Back to Home' : `Back to ${Customer.CustomerName || 'Customer'}`}</span>
                </button>

                <div className={`${styles.modernCard} ${styles.fadeIn}`}>

                    {/* ── Card gradient header ── */}
                    <div className={styles.customerHeader}>
                        <h1 className={styles.customerName}>
                            {isNew ? 'New Customer' : `Edit: ${Customer.CustomerName}`}
                        </h1>
                        <p className={styles.customerNumber}>
                            Customer No <strong>{Customer.CustomerNo}</strong>
                        </p>
                    </div>

                    <div className={styles.cardBodyCustom}>

                        {/* ── Section: Identity ── */}
                        <div className={styles.formSection}>
                            <p className={styles.formSectionTitle}>Identity</p>
                            <div className="row g-3">
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel} htmlFor="f-CustomerNo">Customer No</label>
                                    <input
                                        disabled
                                        type="text"
                                        id="f-CustomerNo"
                                        className={styles.formControl}
                                        value={Customer.CustomerNo}
                                        readOnly
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel} htmlFor="f-CustomerName">Customer Name *</label>
                                    <input
                                        disabled={nameDisabled}
                                        type="text"
                                        id="f-CustomerName"
                                        className={styles.formControl}
                                        value={Customer.CustomerName}
                                        onChange={this.onTarget}
                                        placeholder="Full business name"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel} htmlFor="f-EmailAddress">Email Address</label>
                                    <input
                                        type="email"
                                        id="f-EmailAddress"
                                        className={styles.formControl}
                                        value={Customer.EmailAddress}
                                        onChange={this.onTarget}
                                        placeholder="contact@business.com"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel} htmlFor="f-TelephoneNo">Phone Number</label>
                                    <input
                                        type="text"
                                        id="f-TelephoneNo"
                                        className={styles.formControl}
                                        value={Customer.TelephoneNo}
                                        onChange={this.onTarget}
                                        placeholder="+1 (555) 000-0000"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel} htmlFor="f-Fax">Fax</label>
                                    <input
                                        type="text"
                                        id="f-Fax"
                                        className={styles.formControl}
                                        value={Customer.Fax}
                                        onChange={this.onTarget}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel}>Sales Person</label>
                                    <input
                                        disabled
                                        type="text"
                                        className={styles.formControl}
                                        value={Customer.SalespersonNo}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>

                        {/* ── Section: Address ── */}
                        <div className={styles.formSection}>
                            <p className={styles.formSectionTitle}>Address</p>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className={styles.formLabel} htmlFor="f-AddressLine1">Address Line</label>
                                    <input
                                        type="text"
                                        id="f-AddressLine1"
                                        className={styles.formControl}
                                        value={Customer.AddressLine1}
                                        onChange={this.onTarget}
                                        placeholder="123 Main Street"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <label className={styles.formLabel} htmlFor="f-City">City</label>
                                    <input
                                        type="text"
                                        id="f-City"
                                        className={styles.formControl}
                                        value={Customer.City}
                                        onChange={this.onTarget}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <label className={styles.formLabel} htmlFor="f-State">State</label>
                                    <input
                                        type="text"
                                        id="f-State"
                                        className={styles.formControl}
                                        value={Customer.State}
                                        onChange={this.onTarget}
                                        placeholder="AL"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <label className={styles.formLabel} htmlFor="f-ZipCode">Zip Code</label>
                                    <input
                                        type="text"
                                        id="f-ZipCode"
                                        className={styles.formControl}
                                        value={Customer.ZipCode}
                                        onChange={this.onTarget}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className={styles.formLabel}>Country</label>
                                    <input
                                        disabled
                                        type="text"
                                        className={styles.formControl}
                                        value={Customer.Country}
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>

                        {/* ── Section: Commercial Settings ── */}
                        <div className={styles.formSection}>
                            <p className={styles.formSectionTitle}>Commercial Settings</p>
                            <div className="row g-3">
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel}>Route</label>
                                    <Select
                                        value={selectedOption2}
                                        options={optionsSelect2}
                                        onChange={e => this.onChangeSelects(e, 'Route')}
                                        placeholder="Select route…"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <label className={styles.formLabel}>Taxable</label>
                                    <Select
                                        value={selectedOption1}
                                        options={optionsSelect1}
                                        onChange={e => this.onChangeSelects(e, 'Tax')}
                                        placeholder="Select tax…"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <label className={styles.formLabel}>Terms Code</label>
                                    <Select
                                        isDisabled={securityDisabled}
                                        value={selectedOption3}
                                        options={optionsSelect3}
                                        onChange={e => this.onChangeSelects(e, 'TermsCode')}
                                        placeholder="Select terms…"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <label className={styles.formLabel}>Price Level</label>
                                    <Select
                                        isDisabled={securityDisabled}
                                        value={selectedOption4}
                                        options={optionsSelect4}
                                        onChange={e => this.onChangeSelects(e, 'PriceLevel')}
                                        placeholder="Select level…"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4">
                                    <label className={styles.formLabel} htmlFor="f-CreditLimit">Credit Limit</label>
                                    <div className={styles.inputGroup}>
                                        <span className={styles.inputGroupText}>$</span>
                                        <input
                                            disabled={securityDisabled}
                                            type="number"
                                            id="f-CreditLimit"
                                            className={`${styles.formControl} ${styles.inputGroupField}`}
                                            value={Customer.CreditLimit}
                                            onChange={this.onTarget}
                                            min={0}
                                            step={0.01}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ── Actions ── */}
                        <div className="d-flex gap-3 justify-content-end flex-wrap">
                            <button
                                className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`}
                                onClick={() => this.setState({ view: isNew ? 'landing' : 'detail' })}
                            >
                                <AiOutlineClose /> Cancel
                            </button>
                            <button
                                className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                disabled={!Customer.CustomerNo}
                                onClick={this.saveCustomer}
                            >
                                <AiOutlineSave />
                                {isNew ? 'Create Customer' : 'Update Customer'}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Render: Detail view
    // ─────────────────────────────────────────────────────────────────────────

    renderDetail() {
        const { selectedCustomer, invoiceList } = this.state;
        if (!selectedCustomer) return null;

        return (
            <div className={`${styles.customerContent} ${styles.active}`}>

                {/* ── Breadcrumb ── */}
                <button className={styles.viewBreadcrumb} onClick={this.clearCustomer}>
                    <AiOutlineArrowLeft />
                    <span>Back to Home</span>
                </button>

                <div className="row g-4">

                    {/* ── Customer header card ── */}
                    <div className="col-12">
                        <div className={`${styles.modernCard} ${styles.fadeIn}`}>
                            <div className={styles.customerHeader}>
                                <h1 className={styles.customerName}>
                                    {selectedCustomer.name}
                                    <span style={{ fontSize: '1rem', fontWeight: 400, opacity: 0.8, marginLeft: '0.75rem' }}>
                                        · Level {selectedCustomer.priceLevel}
                                    </span>
                                </h1>
                                <p className={styles.customerNumber}>
                                    Customer No <strong>{selectedCustomer.customerNo}</strong>
                                    &nbsp;&nbsp;·&nbsp;&nbsp;
                                    Sales Person <strong>{selectedCustomer.salespersonNo}</strong>
                                </p>
                            </div>
                            <div className={styles.cardBodyCustom}>
                                <div className={styles.infoGrid}>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>Email</span>
                                        <span className={styles.infoValue}>{selectedCustomer.emailAddress || 'No Data'}</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>Phone</span>
                                        <span className={styles.infoValue}>{selectedCustomer.telephoneNo || 'No Data'}</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>Address</span>
                                        <span className={styles.infoValue}>{selectedCustomer.addressLine1 || 'No Data'}</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>City, State ZIP</span>
                                        <span className={styles.infoValue}>
                                            {[selectedCustomer.city, selectedCustomer.state, selectedCustomer.zipCode]
                                                .filter(Boolean).join(' ') || 'No Data'}
                                        </span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>Route</span>
                                        <span className={styles.infoValue}>{selectedCustomer.udf_ruta || 'No Data'}</span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>Terms Code</span>
                                        <span className={styles.infoValue}>
                                            {this.textTermsCode(selectedCustomer.termsCode) || selectedCustomer.taxSchedule || 'No Data'}
                                        </span>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span className={styles.infoLabel}>Credit Limit</span>
                                        <span className={styles.infoValue}>{this.formatCurrency(selectedCustomer.creditLimit)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Invoice history ── */}
                    <div className="col-12">
                        <div className={`${styles.modernCard} ${styles.fadeIn}`}>
                            <div className={styles.cardHeaderCustom}>
                                <div className="d-flex align-items-center flex-wrap gap-2">
                                    <div className="flex-grow-1">
                                        <h3 className={styles.cardTitle}>Invoice History</h3>
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap gap-2">
                                        <label htmlFor="dateStart" className="mb-0 fw-semibold" style={{ fontSize: '0.875rem' }}>From</label>
                                        <input type="date" id="dateStart" className={styles.dateInput} />
                                        <label htmlFor="dateEnd" className="mb-0 fw-semibold" style={{ fontSize: '0.875rem' }}>To</label>
                                        <input type="date" id="dateEnd" className={styles.dateInput} />
                                        <button
                                            className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                            style={{ padding: '0.5rem 1.25rem', fontSize: '0.875rem' }}
                                            onClick={this.searchByDates}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.cardBodyCustom}>
                                {invoiceList.length === 0 ? (
                                    <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem 0', margin: 0 }}>
                                        No invoices found. Try adjusting the date range.
                                    </p>
                                ) : (
                                    <div className={styles.invoiceList}>
                                        {invoiceList.map(inv => (
                                            <div
                                                key={inv.InvoiceNo}
                                                className={styles.invoiceItem}
                                                onClick={() => this.openInvoiceModal(inv)}
                                                data-bs-toggle="modal"
                                                data-bs-target="#invoiceModal"
                                            >
                                                <div className={styles.invoiceMain}>
                                                    <div className={styles.invoiceNumber}>{inv.InvoiceNo}</div>
                                                    <div className={styles.invoiceDate}>
                                                        {this.formatDate(new Date(inv.InvoiceDate))}
                                                        {inv.Comment ? ` · ${inv.Comment}` : ''}
                                                    </div>
                                                </div>
                                                <div className={styles.invoiceAmount}>{this.formatCurrency(inv.Total)}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ── Contacts ── */}
                    {this.renderContacts()}

                    {/* ── Actions ── */}
                    <div className="col-12">
                        <div className={`${styles.modernCard} ${styles.fadeIn}`}>
                            <div className={styles.cardHeaderCustom}>
                                <h3 className={styles.cardTitle}>Actions</h3>
                            </div>
                            <div className={styles.cardBodyCustom}>
                                <div className="row g-3">
                                    <div className="col-sm-12 col-md-auto">
                                        <button
                                            className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                            style={{ width: '100%', justifyContent: 'center' }}
                                            onClick={this.startEditCustomer}
                                        >
                                            <AiFillEdit /> Edit Customer
                                        </button>
                                    </div>
                                    <div className="col-sm-12 col-md-auto">
                                        <button
                                            className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`}
                                            style={{ width: '100%', justifyContent: 'center' }}
                                            onClick={this.clearCustomer}
                                        >
                                            <AiOutlineClose /> Back to Home
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Render: Contacts sub-module
    // ─────────────────────────────────────────────────────────────────────────

    renderContacts() {
        const { contacts, showContactForm, contactFormMode, contactForm } = this.state;

        return (
            <div className="col-12">
                <div className={`${styles.modernCard} ${styles.fadeIn}`}>
                    {/* ── Header ── */}
                    <div className={styles.cardHeaderCustom}>
                        <div className="d-flex align-items-center justify-content-between">
                            <h3 className={styles.cardTitle}>
                                <FaAddressBook style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
                                Contacts
                            </h3>
                            {!showContactForm && (
                                <button
                                    className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                    style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}
                                    onClick={this.openAddContact}
                                >
                                    <AiOutlineUserAdd /> Add Contact
                                </button>
                            )}
                        </div>
                    </div>

                    <div className={styles.cardBodyCustom}>
                        {/* ── Inline form ── */}
                        {showContactForm && (
                            <div className={styles.contactFormBox}>
                                <p className={styles.formSectionTitle}>
                                    {contactFormMode === 'new' ? 'New Contact' : 'Edit Contact'}
                                </p>
                                <div className="row g-3 mb-3">
                                    <div className="col-sm-6">
                                        <label className={styles.formLabel} htmlFor="cf-firstName">First Name *</label>
                                        <input
                                            type="text"
                                            id="cf-firstName"
                                            className={styles.formControl}
                                            value={contactForm.firstName}
                                            onChange={e => this.setContactField('firstName', e.target.value)}
                                            placeholder="John"
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className={styles.formLabel} htmlFor="cf-lastName">Last Name</label>
                                        <input
                                            type="text"
                                            id="cf-lastName"
                                            className={styles.formControl}
                                            value={contactForm.lastName}
                                            onChange={e => this.setContactField('lastName', e.target.value)}
                                            placeholder="Doe"
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className={styles.formLabel} htmlFor="cf-email">Email</label>
                                        <input
                                            type="email"
                                            id="cf-email"
                                            className={styles.formControl}
                                            value={contactForm.email}
                                            onChange={e => this.setContactField('email', e.target.value)}
                                            placeholder="john@company.com"
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className={styles.formLabel} htmlFor="cf-phone">Phone</label>
                                        <input
                                            type="text"
                                            id="cf-phone"
                                            className={styles.formControl}
                                            value={contactForm.phone}
                                            onChange={e => this.setContactField('phone', e.target.value)}
                                            placeholder="+1 (555) 000-0000"
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label className={styles.formLabel} htmlFor="cf-position">Position / Role</label>
                                        <input
                                            type="text"
                                            id="cf-position"
                                            className={styles.formControl}
                                            value={contactForm.position}
                                            onChange={e => this.setContactField('position', e.target.value)}
                                            placeholder="Purchasing Manager"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex gap-2">
                                    <button
                                        className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`}
                                        onClick={() => this.setState({ showContactForm: false })}
                                    >
                                        <AiOutlineClose /> Cancel
                                    </button>
                                    <button
                                        className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                        onClick={this.saveContact}
                                    >
                                        <AiOutlineSave /> Save Contact
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* ── Contact list ── */}
                        {contacts.length === 0 ? (
                            <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem 0', margin: 0 }}>
                                No contacts registered yet. Click "Add Contact" to get started.
                            </p>
                        ) : (
                            <div className={styles.contactList}>
                                {contacts.map(contact => (
                                    <div
                                        key={contact.id}
                                        className={`${styles.contactItem} ${!contact.isActive ? styles.contactInactive : ''}`}
                                    >
                                        {/* Avatar initials */}
                                        <div className={styles.contactAvatar}>
                                            {(contact.firstName || '').charAt(0)}
                                            {(contact.lastName  || '').charAt(0)}
                                        </div>

                                        {/* Info */}
                                        <div className={styles.contactInfo}>
                                            <div className={styles.contactName}>
                                                {contact.firstName} {contact.lastName}
                                                {contact.isPrimary === 1 && (
                                                    <span className={`${styles.badgeCustom} ${styles.badgePrimary}`}>Primary</span>
                                                )}
                                                {contact.isActive === 0 && (
                                                    <span className={`${styles.badgeCustom} ${styles.badgeWarning}`}>Inactive</span>
                                                )}
                                            </div>
                                            {contact.position && (
                                                <div className={styles.contactMeta}>{contact.position}</div>
                                            )}
                                            <div className={styles.contactMeta}>
                                                {[contact.email, contact.phone].filter(Boolean).join(' · ')}
                                            </div>
                                        </div>

                                        {/* Action buttons */}
                                        <div className={styles.contactActions}>
                                            {/* Edit */}
                                            <button
                                                className={styles.contactActionBtn}
                                                title="Edit"
                                                onClick={() => this.startEditContact(contact)}
                                            >
                                                <AiFillEdit />
                                            </button>

                                            {/* Set primary (only for active non-primary contacts) */}
                                            {contact.isPrimary !== 1 && contact.isActive === 1 && (
                                                <button
                                                    className={styles.contactActionBtn}
                                                    title="Set as primary"
                                                    onClick={() => this.setPrimaryContact(contact.id)}
                                                >
                                                    <AiOutlineStar />
                                                </button>
                                            )}
                                            {contact.isPrimary === 1 && (
                                                <button
                                                    className={styles.contactActionBtn}
                                                    title="Primary contact"
                                                    style={{ color: '#F59E0B', borderColor: '#FDE68A', background: '#FFFBEB', cursor: 'default' }}
                                                >
                                                    <AiFillStar />
                                                </button>
                                            )}

                                            {/* Toggle active */}
                                            <button
                                                className={`${styles.contactActionBtn} ${contact.isActive === 1 ? styles.contactBtnDeactivate : styles.contactBtnActivate}`}
                                                title={contact.isActive === 1 ? 'Deactivate' : 'Activate'}
                                                onClick={() => this.toggleContact(contact.id, contact.isActive === 1)}
                                            >
                                                {contact.isActive === 1
                                                    ? <AiOutlineStop />
                                                    : <AiOutlineCheckCircle />}
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Render: Invoice modal
    // ─────────────────────────────────────────────────────────────────────────

    renderInvoiceModal() {
        const { selectedInvoice, selectedCustomer } = this.state;
        const hasItems = selectedInvoice && selectedInvoice.items && selectedInvoice.items.length > 0;

        return (
            <div className="modal" id="invoiceModal">
                <div className="modal-dialog modal-xl">
                    <div className={`modal-content ${styles.modalContent}`}>

                        <div className={`modal-header ${styles.modalHeader} justify-content-between align-items-start`}>
                            <div>
                                <h5 className={styles.modalTitle}>
                                    Invoice {selectedInvoice ? selectedInvoice.InvoiceNo : '—'}
                                </h5>
                                <p className={styles.modalSubtitle}>
                                    {selectedCustomer ? selectedCustomer.name : ''}
                                </p>
                            </div>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" />
                        </div>

                        <div className={`modal-body ${styles.modalBody}`}>
                            {!hasItems ? (
                                <div className="text-center py-5" style={{ color: 'var(--text-secondary)' }}>
                                    <div className="spinner-border spinner-border-sm me-2" role="status" />
                                    Loading invoice details…
                                </div>
                            ) : (
                                <>
                                    {/* Info grid */}
                                    <div className={styles.modalInfoGrid}>
                                        <div>
                                            <div className={styles.modalInfoItem}>
                                                <span className={styles.modalInfoLabel}>Invoice Date:</span>
                                                <span className={styles.modalInfoValue}>
                                                    {selectedInvoice.InvoiceDate
                                                        ? new Date(selectedInvoice.InvoiceDate).toLocaleDateString('en-US')
                                                        : '—'}
                                                </span>
                                            </div>
                                            <div className={styles.modalInfoItem}>
                                                <span className={styles.modalInfoLabel}>Comment:</span>
                                                <span className={styles.modalInfoValue}>{selectedInvoice.Comment || '—'}</span>
                                            </div>
                                            <div className={styles.modalInfoItem}>
                                                <span className={styles.modalInfoLabel}>Sales Person:</span>
                                                <span className={styles.modalInfoValue}>{selectedCustomer ? selectedCustomer.salespersonNo : '—'}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div className={styles.modalInfoItem}>
                                                <span className={styles.modalInfoLabel}>Invoice Type:</span>
                                                <span className={styles.modalInfoValue}>{selectedInvoice.InvoiceType || '—'}</span>
                                            </div>
                                            <div className={styles.modalInfoItem}>
                                                <span className={styles.modalInfoLabel}>Qty Shipped:</span>
                                                <span className={styles.modalInfoValue}>{selectedInvoice.totalQShipped || 0} units</span>
                                            </div>
                                            <div className={styles.modalInfoItem}>
                                                <span className={styles.modalInfoLabel}>Weight:</span>
                                                <span className={styles.modalInfoValue}>
                                                    {Number(selectedInvoice.totalWeight || 0).toFixed(2)} lbs
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items table */}
                                    <h6 className={styles.modalTitleSecondary}>Invoice Items</h6>
                                    <div className={styles.modalTableBox}>
                                        <table className={styles.modalTable}>
                                            <thead>
                                                <tr>
                                                    <th>Item Code</th>
                                                    <th>Description</th>
                                                    <th>Unit Weight</th>
                                                    <th>Q. Ordered</th>
                                                    <th>Q. Shipped</th>
                                                    <th>Unit Price</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedInvoice.items.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.ItemCode}</td>
                                                        <td>{item.Description}</td>
                                                        <td>{item.Weight} lbs</td>
                                                        <td>{item.QuantityOrdered}</td>
                                                        <td>{item.QuantityShipped}</td>
                                                        <td>{this.formatCurrency(item.UnitPrice)}</td>
                                                        <td>{this.formatCurrency(item.Total)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="6" className={styles.modalSummaryRow}>Subtotal:</td>
                                                    <td>{this.formatCurrency(selectedInvoice.totalPrice)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="6" className={styles.modalTotalLabel}>Total:</td>
                                                    <td className={styles.modalTotalText}>{this.formatCurrency(selectedInvoice.totalPrice)}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className={`modal-footer ${styles.modalFooter}`}>
                            <button className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`} data-bs-dismiss="modal">
                                <AiOutlineClose /> Close
                            </button>
                            <button
                                type="button"
                                className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}
                                onClick={this.handlePrint}
                                disabled={!hasItems}
                            >
                                <AiFillPrinter /> Print Invoice
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Render: Browse modal
    // ─────────────────────────────────────────────────────────────────────────

    renderBrowseModal() {
        const { customerList, customerListFilter } = this.state;
        return (
            <div className="modal" id="browseCustomersModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Browse Customers</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className={styles.modalBody}>
                            <div className="mb-3">
                                <input
                                    type="text"
                                    id="searchCustomerFilter"
                                    className={styles.searchInput}
                                    placeholder="Filter by name or number…"
                                    style={{ margin: 0 }}
                                    onKeyUp={this.searchCustomer}
                                />
                            </div>
                            <div className="list-group">
                                {customerList && customerListFilter.map(customer => (
                                    <button
                                        key={customer.customerNo}
                                        className="list-group-item list-group-item-action"
                                        data-bs-dismiss="modal"
                                        onClick={() => this.selectCustomer(customer)}
                                    >
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong>{customer.name}</strong><br />
                                                <small className={styles.smallTextSecondary}>
                                                    {customer.city} | {customer.state}
                                                </small>
                                            </div>
                                            <span className={`${styles.badgeCustom} ${styles.badgeSuccess}`}>
                                                {customer.customerNo}
                                            </span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // Main render
    // ─────────────────────────────────────────────────────────────────────────

    render() {
        const { view } = this.state;

        const subtitleMap = {
            landing: 'Search, browse, or create customers',
            create:  'Fill in the details to register a new customer',
            detail:  'Customer information and invoice history',
            edit:    'Update existing customer information',
        };

        return (
            <div className="container-fluid">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                {/* Page Header */}
                <div className={styles.pageHeader}>
                    <div className="container">
                        <h1 className={styles.pageTitle}>Customer Management</h1>
                        <p className={styles.pageSubtitle}>{subtitleMap[view]}</p>
                    </div>
                </div>

                <div className="container pb-5">
                    {view === 'landing' && this.renderLanding()}
                    {view === 'create'  && this.renderCustomerForm(true)}
                    {view === 'detail'  && this.renderDetail()}
                    {view === 'edit'    && this.renderCustomerForm(false)}
                </div>

                {this.renderInvoiceModal()}
                {this.renderBrowseModal()}
            </div>
        );
    }
}
